declare const window: Window & { sunbitEnv: string };

export const CARD_ENV = window.sunbitEnv;
